import { defineComponent as _defineComponent } from 'vue'
import { computed, type Ref } from 'vue'
import {
  type AccountType,
  useBatchLockImpactsMutation,
  useListImpactGoalsQuery,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'MakeImpactGoalEditable',
  props: {
  selected: {
    type: Array<{ venture: AccountType; ventureId: string }>,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const { mutate: batchLockImpacts, loading } = useBatchLockImpactsMutation()

const ventureIds = computed(() => {
  return props.selected.map((item) => item.ventureId)
})

const { result } = useListImpactGoalsQuery({
  filters: {
    ventureIds: ventureIds.value,
  },
})

const impactIds = computed(() => {
  return (
    result.value?.listImpactGoals?.flatMap((ig) =>
      ig.impacts.map((impact) => impact.id),
    ) || []
  )
    .filter((id): id is number => id !== null && id !== undefined)
})

const handleClick = async (dialog: Ref<boolean>) => {
  if (impactIds.value.length) {
    await batchLockImpacts({
      input: {
        impactIds: impactIds.value,
        operation: 'UNFREEZE',
        lockingLevel: 'PORTFOLIO',
        reason: 'Impact reopened by portfolio.',
      },
    })
  }
  window.$nuxt.$emit('userMsg')
  dialog.value = false
}

return { __sfc: true,props, batchLockImpacts, loading, ventureIds, result, impactIds, handleClick }
}

})